import { SET_CURRENT_ZOOM } from '../actions';

const initial = {
  zoom: 1
};

const openSeadragonOperation = (state = initial, action) => {
  switch (action.type) {
    case SET_CURRENT_ZOOM:
      return {
        ...state,
        zoom: action.zoom
      };
    default:
      return state;
  }
};

export default openSeadragonOperation;
